import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { save } from "../actions/types";
import { push } from "../history";
import SchemaForm from "../components/SchemaForm";
import SelectTile from "../components/fields/SelectTile";
import Header from "../components/Header";
import IconCollection from "../components/icons/Collection";
import IconSingle from "../components/icons/Single";
import utils from "../lib/utils";

@connect()
export default class extends Component {
  static contextTypes = {
    site: PropTypes.object.isRequired,
  };

  state = {
    value: this.getValue(),
  };

  schema = {
    name: {
      required: true,
      help: "Singular name of the content type. e.g. Post, Event",
    },
    group_id: {
      required: true,
      nullOption: false,
      allowedValues: this.context.site.groups.reduce((obj, group) => {
        obj[group.id] = group.name;
        return obj;
      }, {}),
    },
    type: {
      required: true,
      nullOption: false,
      allowedValues: ["collection", "single"],
      options: [
        {
          value: "collection",
          text: (
            <div>
              <IconCollection />
              <h2>Collection</h2>
              <div className="text-left">
                <p>Create many content items with the same type.</p>
                <p>
                  <em>i.e. Blog Post, Event</em>
                </p>
              </div>
            </div>
          ),
        },
        {
          value: "single",
          text: (
            <div>
              <IconSingle />
              <h2>Single</h2>
              <div className="text-left">
                <p>Create a single instance of a content type.</p>
                <p>
                  <em>i.e. Settings, Home Page</em>
                </p>
              </div>
            </div>
          ),
        },
      ],
      template: (props) => (
        <div>
          <SelectTile
            options={props.options}
            onChange={props.onChange}
            value={props.value}
          />
        </div>
      ),
    },
  };

  getValue() {
    const { location } = this.props;
    const { site } = this.context;

    if (location.state && location.state.fromModel) {
      const { name, group_id, collection } = location.state.fromModel;
      return { name, group_id, type: collection ? "collection" : "single" };
    }

    return {
      group_id: site.groups.length ? site.groups[0].id : null,
    };
  }

  onSubmit = async (value) => {
    const { dispatch, location } = this.props;

    if (location.state && location.state.fromModel) {
      const { parts, group_id, options } = location.state.fromModel;
      value = { ...value, parts, group_id, options };
    }

    const {
      error,
      data: { type },
    } = await dispatch(save(value));

    if (error) {
      dispatch(alert({ message: error, type: "error" }));
    }

    if (type && type.slug) {
      push(utils.sectionUrl(type.slug, "edit"));
    }

    return type;
  };

  render() {
    return (
      <div className="content scroll-container new-type">
        <Header title="New Content Type" />
        <SchemaForm
          schema={this.schema}
          value={this.state.value}
          onSubmit={this.onSubmit}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/containers/NewType.js